import { traverseStoryboardExpressions, collectInstalledAppsHasUsage } from "@next-core/utils/storyboard";
import { RuntimeApi_searchMicroAppStandalone } from "@next-api-sdk/micro-app-standalone-sdk";
const checkingApps = new Map();
const checkedApps = new Map();
export function preCheckInstalledApps(storyboard, hasAppInBootstrap) {
  if (window.STANDALONE_MICRO_APPS && !window.NO_AUTH_GUARD) {
    const appIds = scanInstalledAppsUsage(storyboard);
    const searchIds = [];
    for (const appId of appIds) {
      // Do not check these apps already checking or in bootstrap.
      if (!checkingApps.has(appId) && !hasAppInBootstrap(appId)) {
        searchIds.push(appId);
      }
    }
    if (searchIds.length === 0) {
      return;
    }
    const promise = RuntimeApi_searchMicroAppStandalone({
      query: {
        appId: {
          $in: searchIds
        }
      },
      fields: ["appId", "currentVersion", "installStatus"]
    }, {
      noAbortOnRouteChange: true
    }).catch(error => {
      // Allow search micro app to fail, and
      // make it not crash when the backend service is not updated.
      // eslint-disable-next-line no-console
      console.error("Get off site standalone micro-apps failed", error);
    });
    for (const appId of searchIds) {
      checkingApps.set(appId, promise.then(result => {
        var _result$list;
        const app = result === null || result === void 0 || (_result$list = result.list) === null || _result$list === void 0 ? void 0 : _result$list.find(item => item.appId === appId);
        const checkedApp = app ? {
          ...app,
          id: appId
        } : undefined;
        checkedApps.set(appId, checkedApp);
        return checkedApp;
      }));
    }
  }
}
export async function waitForCheckingApps(appIds) {
  await Promise.all(appIds.map(appId => checkingApps.get(appId)));
}
export function getCheckedApp(appId) {
  if (window.STANDALONE_MICRO_APPS) {
    return checkedApps.get(appId);
  }
}
function scanInstalledAppsUsage(storyboard) {
  var _storyboard$meta;
  const usage = {
    usedArgs: new Set()
  };
  // `INSTALLED_APPS.has(...)` is not available in storyboard functions
  const {
    customTemplates,
    menus
  } = (_storyboard$meta = storyboard.meta) !== null && _storyboard$meta !== void 0 ? _storyboard$meta : {};
  traverseStoryboardExpressions([storyboard.routes, customTemplates, menus], (node, parent) => {
    collectInstalledAppsHasUsage(usage, node, parent);
  }, "INSTALLED_APPS");
  return [...usage.usedArgs];
}
//# sourceMappingURL=checkInstalledApps.js.map